import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  Input,
  ElementRef,
  Renderer2,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { LayoutState } from 'src/app/layout/state/layout.state';
import { getVH } from 'src/app/shared/libraries/screen/screen';
import { HelpTypeEnum } from 'src/app/view/models/help-type.enum';
import { ViewState } from 'src/app/view/state/view.state';

@Component({
  selector: 'app-help-dialog',
  templateUrl: './view-help.component.html',
  styleUrls: ['./view-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ViewHelpComponent implements OnInit, AfterViewInit, OnDestroy {
  helpTypeEnum = HelpTypeEnum;

  // --------- Child Elements -----------
  @ViewChild('viewHelp', { static: true })
  viewHelp: ElementRef;

  // --------- Observables ----------
  @Select(ViewState.getCanTouch)
  canTouch$: Observable<boolean>;

  // ---------- Class Variables ----------
  activeTab: HelpTypeEnum = HelpTypeEnum.Basics;

  ngUnsubscribe = new Subject();

  // ---------- Layout ----------
  constructor(
    public dialogRef: MatDialogRef<ViewHelpComponent>,
    private renderer: Renderer2,
    private store: Store,
    @Inject(MAT_DIALOG_DATA) private data: { tab: HelpTypeEnum },
  ) {
    this.activeTab = data.tab;
  }

  ngOnInit(): void {
    this.initWindowSizeObserver();
  }

  ngAfterViewInit() {
    this.updateViewHeight();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initWindowSizeObserver() {
    this.renderer.listen('window', 'resize', () => {
      this.updateViewHeight();
    });
  }

  // // Mobile devices have variable viewheight because the browser bar can scroll in and out of view
  // // This workaround determines the available window space and uses that as a viewheight unit
  updateViewHeight() {
    const siteHeader = this.store.selectSnapshot(LayoutState.getSiteHeader);
    const vh = getVH(siteHeader, false);
    this.viewHelp.nativeElement.style.setProperty('--vh', `${vh}px`);
  }

  // ---------- Interactions ----------
  handleCloseClick() {
    this.dialogRef.close();
  }
}
